import { Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import React from 'react';
export const EllipsisText = ({ variant, children, tooltipText, rows = 1, tooltipAlign, overrideTag, color, className, onClick, }) => {
    const dataTooltipContent = tooltipText ?? (typeof children === 'string' ? children : '');
    return (React.createElement(Typography, { variant: variant, overrideTag: overrideTag, color: color, className: className, onClick: onClick, ellipsis: { rows }, tooltipConfig: {
            showTooltipOnlyOnEllipsis: true,
            dataTooltipContent,
            ...(tooltipAlign ? { dataTooltipAlign: tooltipAlign } : {}),
        } }, children));
};
//# sourceMappingURL=ellipsis-text.js.map